import { Pipe, PipeTransform } from '@angular/core';
import { Modality } from '@core/enum/modality.enum';

@Pipe({ name: 'modalityPipe' })
export class ModalityPipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case Modality.PIX:
        return 'PIX';
      case Modality.BANK_SLIP:
        return 'Boleto';
      case Modality.HYBRID:
        return 'Híbrido';
      default:
        return value;
    }
  }
}
